<template>
  <div class="tag-input-wrapper">
    <div class="__label">{{ fields.label }}</div>
    <div class="mc-tag-input">
      <span 
        v-for="(tag, index) in tags"
        :key="index"
        class="tag"
        >
        {{ tag }}
        <button
          class="delete-button"
          @click="deleteTag(index)"
        >
          &#x2715;
        </button>
      </span>
      <b-form-textarea
        v-model="input"
        rows="3"
        class="tag-input"
        :class="{ 'is-invalid': error, 'border-0': true, 'shadow-none': true }"
        :placeholder="fields.placeholder"
        @keydown.enter.prevent="addTag"
      />
      <div v-if="error" class="invalid-feedback">
        <span>{{ $t(errorMsg) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fields: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      input: '',
      tags: [],
      error: false,
      errorMsg: null,
    }
  },
  mounted() {
    this.tags = [...this.items]
  },
  methods: {
    addTag() {
      if (this.input.trim() === '') return
      
      const duplicateInput = this.tags.includes(this.input.trim())
      if (!duplicateInput) {
        this.tags.push(this.input.trim())
      } else {
        this.error = true
        this.errorMsg = 'duplicate input'
        setTimeout(() => {
          this.error = false
        }, 5000)
        return
      }
      this.input = ''
      this.$emit('input', this.tags)
    },
    deleteTag(index) {
      this.tags.splice(index, 1)
      this.$emit('input', this.tags)
    },
  },
}
</script>

<style lang="scss">
.tag-input-wrapper {
  padding: 4px;

  .__label {
    color: $mep-color-text-300;
    margin-bottom: 8px;
  }
}

.tag {
  display: inline-block;
  background-color: $mep-primary;
  color: white;
  padding: 4px 8px;
  margin-right: 4px;
  margin-bottom: 4px;
  border-radius: 4px;
  overflow-wrap: anywhere;
}

.delete-button {
  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  margin-left: 4px;
  color: white;
  font-weight: 600;
}

.tag-input {
  resize: none;
  height: auto;
  min-height: 40px;
}
</style>
